// extracted by mini-css-extract-plugin
export var headerCell = "_6x-1";
export var loadingSpinnerContainer = "_6x-4";
export var rowWrapper = "_6x-3";
export var standaloneTable = "_6x-5";
export var table = "_6x-0";
export var white = "_6x-2";